import { useState } from 'react';
import { Button } from 'react-bootstrap';
import FormInput from '../../../../components/Form/FormInput';
import Accordion from '../../../../components/Accordion';
import { useInstalacion } from '../../../../hooks/useInstalacion';

const filtroInstalacionIni = {
  nombre: '',
};

export const BuscarInstalacion = () => {
  const { buscarInstalaciones } = useInstalacion();
  const [filtroInstalacion, setFiltroInstalacion] = useState(
    filtroInstalacionIni
  );

  const handleChange = (e: any) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFiltroInstalacion({
      ...filtroInstalacion,
      [name]: value,
    });
  };

  const handleClean = () => {
    setFiltroInstalacion(filtroInstalacionIni);
    buscarInstalaciones(filtroInstalacionIni);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    buscarInstalaciones(filtroInstalacion);
  };

  return (
    <>
      <Accordion
        id={'accordionInstalacionBuscar'}
        title="Consulta de Instalaciones"
        iconoClass="fa fa-search mr-1"
      >
        <div>
          <div className="row mt-3">
            <FormInput
              id={'nombre'}
              label={'Nombre'}
              name={'nombre'}
              placeholder={'Nombre de Instalación'}
              onChange={handleChange}
              value={filtroInstalacion.nombre}
            />
          </div>

          <div className="row mt-3"></div>
          <hr className="m-4" />
          <div className="row mt-3">
            <div className="col-md-12 text-center">
              <Button
                className="btn btn-secondary btn-rounded waves-effect waves-light"
                variant="secondary"
                onClick={handleClean}
              >
                <i className="fa fa-eraser mr-1"></i>
                Limpiar Filtros
              </Button>
              &nbsp;
              <Button
                className="btn btn-success btn-rounded waves-effect waves-light mr-1"
                variant="success"
                type="submit"
                onClick={handleSubmit}
              >
                <i
                  className="fa fa-search mr-1"
                  aria-hidden="true"
                ></i>
                Consultar
              </Button>
            </div>
          </div>
        </div>
      </Accordion>
    </>
  );
};
